import React, { useState } from "react";
import { Card, Typography, Space, Select } from "antd";
import LeaderboardRow from "./LeaderboardRow";
import { useFetchLeaderboards } from "./hooks/getHooks";
import { isNotEmpty } from "../../utils";

const { Title } = Typography;
const { Option } = Select;

const Leaderboard = () => {

  const [timeRange, setTimeRange] = useState("all_time");
  const [rewardType, setRewardType] = useState("points");

  const {leaderboards} = useFetchLeaderboards(timeRange, rewardType)

  return (
    <Card
      style={{ marginTop: 24, borderRadius: 16 }}
      bodyStyle={{ padding: 24 }}
    >
      {/* Header */}
      <Space
        style={{
          justifyContent: "space-between",
          width: "100%",
          marginBottom: 48,
        }}
      >
        <Title level={4} style={{ margin: 0, fontWeight: 400}}>
          Team Leaderboard
        </Title>

        <Select value={timeRange} onChange={(value) => setTimeRange(value)} style={{ width: 160 }}>
          <Option value="week">This Week</Option>
          <Option value="month">This Month</Option>
          <Option value="quarter">This Quarter</Option>
          <Option value="all_time">All Time</Option>
        </Select>
        <Select value={rewardType} onChange={(value) => setRewardType(value)}  style={{ width: 160 }}>
          <Option value="points">Point</Option>
          <Option value="badge">Badge</Option>
          <Option value="monetary">Monetary</Option>
          <Option value="recognition">Reconition</Option>
        </Select>
      </Space>

      {/* Rows */}
      {isNotEmpty(leaderboards) && isNotEmpty(leaderboards.leaderboard) &&
        leaderboards.leaderboard.map((lb) => (
          <LeaderboardRow
            name={lb.user_name}
            // role="Front Desk Manager"
            rewardType={rewardType}
            amount={lb.earned_rewards}
            // points="2,450"
            // badges={3}
            rank={lb.rank}
            topPerformer={lb.rank == 1}
            // tags={[
            //   { label: "Top Performer", color: "gold" },
            //   { label: "AR Champion", color: "green" },
            //   { label: "Streak 30", color: "purple" },
            // ]}
          />
        ))
      }

      {/* <LeaderboardRow
        name="Michael Chen"
        role="Patient Coordinator"
        points="2,180"
        badges={2}
        rank={2}
        tags={[
          { label: "Treatment Expert", color: "blue" },
          { label: "Engagement Pro", color: "red" },
        ]}
      />

      <LeaderboardRow
        name="Emily Rodriguez"
        role="Billing Specialist"
        points="2,050"
        badges={2}
        rank={3}
        tags={[
          { label: "AR Champion", color: "green" },
          { label: "Consistent Performer", color: "cyan" },
        ]}
      /> */}
    </Card>
  );
};

export default Leaderboard;